import I18N from '@leverege/i18n';
const TYPE = 'historyAccumulator.identity';
const {
  tf
} = I18N.ns('molten.dataViewers.map.IdentityHistoryAccumulator');
function create() {
  return {
    type: TYPE
  };
}
function pointsFor(model, inPoints, context) {
  return inPoints;
}
export default {
  TYPE,
  create,
  name: tf('default'),
  pointsFor
};